import { themeBalham, iconSetMaterial, colorSchemeDark } from 'ag-grid-community';
import { useTheme } from '@/providers/ThemeProvider';

const gridThemeLight = themeBalham.withPart(iconSetMaterial).withParams({
  headerRowBorder: true,
  wrapperBorder: false,
});

const gridThemeDark = gridThemeLight.withPart(colorSchemeDark);

export const useGridTheme = () => {
  const { isDarkMode } = useTheme();
  return isDarkMode ? gridThemeDark : gridThemeLight;
};
